export const FETCH_ONBOARDING_SPONSOR_CONFIG_REQUEST = 'FETCH_ONBOARDING_SPONSOR_CONFIG_REQUEST';
export const FETCH_ONBOARDING_SPONSOR_CONFIG_SUCCESS = 'FETCH_ONBOARDING_SPONSOR_CONFIG_SUCCESS';
export const FETCH_ONBOARDING_SPONSOR_CONFIG_FAILURE = 'FETCH_ONBOARDING_SPONSOR_CONFIG_FAILURE';

export const UPDATE_ONBOARDING_SPONSOR_CONFIG_REQUEST = 'UPDATE_ONBOARDING_SPONSOR_CONFIG_REQUEST';
export const UPDATE_ONBOARDING_SPONSOR_CONFIG_SUCCESS = 'UPDATE_ONBOARDING_SPONSOR_CONFIG_SUCCESS';
export const UPDATE_ONBOARDING_SPONSOR_CONFIG_FAILURE = 'UPDATE_ONBOARDING_SPONSOR_CONFIG_FAILURE';

export const fetchOnboardingSponsorConfig = () => ({
    type: FETCH_ONBOARDING_SPONSOR_CONFIG_REQUEST
});

export const updateOnboardingSponsorConfig = (config) => ({
    type: UPDATE_ONBOARDING_SPONSOR_CONFIG_REQUEST,
    payload: config
});
